import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import SameObjectWebhookEventsTable from 'automation-ui-enrollment/components/eventEnrollment/webhooks/SameObjectWebhookEventsTable';
import WebhookEventsDescription from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhookEventsDescription';
import WebhookPanelFullWidthHR from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhookPanelFullWidthHR';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WebhooksForSameObjectView = ({
  footer,
  webhooks,
  objectTypeId,
  setShowWizard,
  handleWebhookSelect,
  setWebhookStagedForEdit,
  setWebhookStagedForDeletion
}) => {
  if (webhooks.length === 0) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(WebhookEventsDescription, {}), /*#__PURE__*/_jsxs("div", {
        className: "m-y-8 text-center",
        children: [/*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation-ui-enrollment.redesign.events.webhookEvents.noWebhooks.sameObjectEmptyState_cob",
          objectTypeId: objectTypeId
        }), /*#__PURE__*/_jsxs(UIButton, {
          className: "m-top-4",
          use: "tertiary",
          size: "small",
          onClick: () => setShowWizard(true),
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "add"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.events.webhookEvents.addNewWebhook"
          })]
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(WebhookEventsDescription, {}), /*#__PURE__*/_jsx(WebhookPanelFullWidthHR, {}), /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-enrollment.redesign.events.webhookEvents.objectTypeHeader_cob",
        objectTypeId: objectTypeId
      })
    }), /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "300",
      as: "div",
      children: [/*#__PURE__*/_jsx(SameObjectWebhookEventsTable, {
        webhooks: webhooks,
        handleWebhookSelect: handleWebhookSelect,
        setWebhookStagedForEdit: setWebhookStagedForEdit,
        setWebhookStagedForDeletion: setWebhookStagedForDeletion
      }), footer]
    })]
  });
};
export default WebhooksForSameObjectView;